<template>
  <div
    :class="{
      'md:h-[100vh] md:max-h-[100vh] md:pt-[var(--header-height)]':
        layoutSettings?.header === 'fixed',
      'md:h-[calc(100vh-var(--header-height))] md:max-h-[calc(var(--app-height)-var(--header-height))]':
        layoutSettings?.header === 'sticky' ||
        layoutSettings?.header === 'static',
      'h-[calc(100vh-8*var(--spacing))] max-h-[calc(var(--app-height)-8*var(--spacing))]':
        !hideHeader && !hideTopBar,
      'h-dvh max-h-dvh': hideHeader || hideTopBar,
    }"
    data-sidebar-padding="animate"
    class="relative overflow-hidden"
  >
    <div class="pointer-events-none absolute left-0 top-0 z-[5] h-full w-full">
      <div
        v-if="
          currentInteractive?.is_360 && currentInteractive?.frame.is_360_frame
        "
        class="pointer-events-all pointer-events-all border-1 shadow-around pointer-events-auto absolute right-1 ms-1 flex flex items-center gap-1 rounded-t-2xl border-gray-100 bg-white/70 px-1.5 pt-1.5 shadow-neutral-400/20 backdrop-blur dark:border-neutral-800 dark:bg-neutral-900/90 dark:shadow-none md:bottom-4 md:right-4 md:rounded-b-2xl md:px-2 md:pb-2 md:pt-2 md:shadow-neutral-500/30"
        :class="{
          'rounded-b-xs bottom-[calc(8*var(--spacing)+env(safe-area-inset-bottom))] pb-4':
            !hideHeader,
          'bottom-[calc(4*var(--spacing)+env(safe-area-inset-bottom))] rounded-b-2xl pb-1.5':
            hideHeader,
        }"
      >
        <button
          class="size-8 md:size-9 hover:bg-primary-active bg-primary text-onPrimary flex cursor-pointer items-center justify-center rounded-lg transition-colors"
          @click="scroll360(-1)"
        >
          <lucide-icon icon="ChevronLeft" size="22" />
        </button>
        <button
          class="size-8 md:size-9 hover:bg-primary-active bg-primary text-onPrimary flex cursor-pointer items-center justify-center rounded-lg transition-colors"
          @click="scroll360(1)"
        >
          <lucide-icon icon="ChevronRight" size="22" />
        </button>
      </div>
    </div>

    <LoadingOverlay
      size="md"
      class=""
      :active="isLoaded && canvasLoading.state"
      :overlay="false"
      :delay="100"
    >
    </LoadingOverlay>

    <Interactive
      v-if="currentInteractive"
      :key="`interactive-${interactiveKey}`"
      :current-interactive="currentInteractive"
      @loaded="loaded"
      @error="error"
      @changeAnimationState="changeAnimationState"
      @defaultImageLoaded="defaultImageLoaded"
      @preloadInteractive="preloadInteractive"
      @updateInteractive="updateInteractive"
      @functions="setInteractiveFunctions"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import Interactive from '@/components/interactive/Interactive';
import LoadingOverlay from '@/components/ui/LoadingOverlay';

export default {
  name: 'PageInteractive',
  components: {
    Interactive,
    LoadingOverlay,
  },
  data() {
    return {
      interactiveFunctions: null,
      // loading
      axiosLoading: {
        interactiveId: null,
        frameId: null,
        storeyId: null,
        state: false,
      },
      canvasLoading: {
        state: false,
        timeout: null,
      },
      mediaLoading: {
        frame: {
          preview: false,
          default: false,
        },
        360: {
          preview: false,
          default: false,
        },
      },

      currentInteractive: null,
      loadedInteractive: null,

      // loading: true,
      interactiveKey: 0,
      isAnimationPlaying: false,

      loadedInteractiveId: null,
      // loadingTimeout: null,
      interactiveBootLoading: false,
    };
  },
  computed: {
    ...mapGetters(['isLoaded', 'layoutSettings', 'hideHeader', 'hideTopBar']),
  },
  watch: {
    '$route.params.frameId': {
      handler: async function (id, oldId) {
        // Обработка переходов по страницам назад вперед
        if (
          this.axiosLoading.interactiveId == this.$route.params.interactiveId &&
          this.axiosLoading.frameId == this.$route.params.frameId
        ) {
          return;
        }

        let waitForAnimation = false;
        const currentInteractiveId = this.axiosLoading.interactiveId;

        if (currentInteractiveId) {
          waitForAnimation = true;
        }

        this.loadInteractive({
          interactiveId: this.$route.params.interactiveId,
          frameId: this.$route.params.frameId,
          storeyId: this.$route.params.storeyId ?? '',
        }).then(() => {
          if (!waitForAnimation) {
            this.setCurrentInteractive();
          }
        });

        if (currentInteractiveId) {
          this.interactiveFunctions.fadeOut().then(() => {
            waitForAnimation = false;
            if (this.axiosLoading.state) {
              this.setCanvasLoading();
            } else {
              this.setCurrentInteractive();
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.LOAD_END('navigate');
  },
  methods: {
    ...mapActions(['GET_INTERACTIVE', 'LOAD_END']),

    setInteractiveFunctions(data) {
      this.interactiveFunctions = data;
    },

    changeAnimationState(state) {
      this.isAnimationPlaying = state;
    },

    loadImage(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve(url);
        };
        img.onerror = () => {
          reject(url);
        };
        img.src = url;
      });
    },

    async defaultImageLoaded() {
      if (
        this.loadedInteractiveId !== this.currentInteractive.id &&
        this.currentInteractive.is_360
      ) {
        const urls = this.currentInteractive.frames
          .filter((frame) => frame.is_360_frame)
          .map((frame) => frame.image.default_url);
        try {
          // const results = await Promise.allSettled(urls.map(this.loadImage));
        } catch (error) {
          // console.error("Unexpected error during preloading", error);
        }
      }
      this.loadedInteractiveId = this.currentInteractive.id;
    },

    endCanvasLoading() {
      if (this.canvasLoading.timeout) {
        clearTimeout(this.canvasLoading.timeout);
      }
      this.canvasLoading.state = false;
    },

    loaded() {
      this.endCanvasLoading();
    },

    error() {
      this.interactiveKey++;
      this.endCanvasLoading();
    },

    async preloadInteractive({ interactiveId, frameId, storeyId = '' }) {
      await this.loadInteractive({ interactiveId, frameId, storeyId });
      if (this.isAnimationPlaying === false) {
        this.setCurrentInteractive();
      }
    },

    async loadInteractive({ interactiveId, frameId, storeyId = '' }) {
      this.axiosLoading.state = true;
      this.axiosLoading.interactiveId = interactiveId * 1;
      this.axiosLoading.frameId = frameId * 1;
      this.axiosLoading.storeyId = storeyId;

      return new Promise((resolve, reject) => {
        this.GET_INTERACTIVE({
          id: interactiveId,
          frame: frameId,
          storey: storeyId,
        })
          .then((response) => {
            this.loadedInteractive = { ...response };
            this.axiosLoading.state = false;
            resolve();
          })
          .catch((error) => {
            this.axiosLoading.state = false;
            reject(error);
          });
      });
    },

    setCurrentInteractive() {
      // this.interactiveKey++;
      this.currentInteractive = this.loadedInteractive;
    },

    setCanvasLoading(delay = 100) {
      this.canvasLoading.timeout = setTimeout(() => {
        this.canvasLoading.state = true;
      }, delay);
    },

    updateInteractive() {
      if (this.axiosLoading.state) {
        this.setCanvasLoading();
      } else {
        this.setCurrentInteractive();
      }
    },

    findClosest360Frame(direction) {
      const currentIndex = this.currentInteractive.frames.findIndex(
        (frame) => frame.id === this.currentInteractive.frame.id
      );

      let next360Frame;
      if (direction === 1) {
        next360Frame = this.currentInteractive.frames
          .slice(currentIndex + 1)
          .find((frame) => frame.is_360_frame && frame.has_layers);

        // If not found, loop around to the beginning
        if (!next360Frame) {
          next360Frame = this.currentInteractive.frames.find(
            (frame) => frame.is_360_frame && frame.has_layers
          );
        }
      } else {
        next360Frame = this.currentInteractive.frames
          .slice(0, currentIndex)
          .reverse()
          .find((frame) => frame.is_360_frame && frame.has_layers);

        // If not found, loop around from the end
        if (!next360Frame) {
          next360Frame = this.currentInteractive.frames
            .slice()
            .reverse()
            .find((frame) => frame.is_360_frame && frame.has_layers);
        }
      }

      return next360Frame;
    },

    scroll360(direction) {
      if (this.isAnimationPlaying) {
        return;
      }

      const frame = this.findClosest360Frame(direction);
      if (!frame) {
        return;
      }

      this.preloadInteractive({
        interactiveId: this.currentInteractive.id,
        frameId: frame.id,
      });
      if (this.currentInteractive.frame.id !== frame.id) {
        this.$router.push({
          name: 'Interactive',
          params: {
            interactiveId: this.currentInteractive.id,
            frameId: frame.id,
            replace: true,
          },
        });
      }
      this.interactiveFunctions
        .scrollToFrame(frame.id, direction)
        .then(this.updateInteractive);
    },

    isMobile() {
      return window.innerWidth < 767;
    },
  },
};
</script>
<style scoped></style>
